import { render, staticRenderFns } from "./xasc.vue?vue&type=template&id=61ae604f"
import script from "./xasc.vue?vue&type=script&lang=js"
export * from "./xasc.vue?vue&type=script&lang=js"
import style0 from "./xasc.vue?vue&type=style&index=0&id=61ae604f&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports